import React from 'react';
import { Dropdown } from './Dropdown';
import { ENGINE_OPTIONS, canUseEngine, type Engine } from 'api/analysisApi';
import { useAuthStore } from 'store/useAuthStore';

interface EngineSelectProps {
	open: boolean;
	anchor: HTMLElement | null;
	selected: Engine;
	onSelect: (engine: Engine) => void;
	onClose: () => void;
}

/**
 * Compact picker for the Analysis calc engine (v0/v1/v2/v3). Reuses the shared
 * Dropdown + the tf-item row styling so it matches the pair/timeframe selectors.
 */
export function EngineSelect({ open, anchor, selected, onSelect, onClose }: EngineSelectProps) {
	const user = useAuthStore((s) => s.user);
	return (
		<Dropdown open={open} anchor={anchor} onClose={onClose} width={210}>
			{ENGINE_OPTIONS.filter((opt) => !opt.pickerHidden && canUseEngine(user, opt.value)).map((opt) => {
				const active = opt.value === selected;
				return (
					<button
						key={opt.value}
						type='button'
						className={`tf-item${active ? ' active' : ''}`}
						onClick={() => {
							onSelect(opt.value);
							onClose();
						}}
					>
						<span className='tf-item-text'>{opt.label}</span>
						<span className={`tf-item-tag${active ? ' active' : ''}`}>{opt.badge.split(' ').pop()}</span>
					</button>
				);
			})}
		</Dropdown>
	);
}
